import { render, staticRenderFns } from "./Partages.vue?vue&type=template&id=c32ab9d8&"
import script from "./Partages.vue?vue&type=script&lang=js&"
export * from "./Partages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports